import { fmt, type ValueKind } from '../insightFormat';
import type { CsvCell } from '../../../core/rules/csv';
export type Column = {
  label: string;
  kind?: ValueKind | 'text';
};
export type TableData = {
  columns: Column[];
  rows: CsvCell[][];
};
type Props = TableData & {
  caption: string;
  className?: string;
};

/** De cijfers achter een grafiek als gewone tabel: om te lezen, voor schermlezers en als CSV. */
export function DataTable({
  columns,
  rows,
  caption,
  className = ''
}: Props) {
  if (rows.length === 0) return <p className={`py-6 text-center text-[13px] text-muted ${className}`} data-id="element-1787" data-mp="10f9oz0c7682e">Niets in deze periode.</p>;
  return <div className={`-mx-4 overflow-x-auto sm:mx-0 ${className}`} data-id="element-1788" data-mp="155zwok83in09">
      <table className="w-full min-w-max text-[13px]" data-id="element-1789" data-mp="158m66pejrcl4">
        <caption className="sr-only" data-id="element-1790" data-mp="1a41hb9l66udu">{caption}</caption>
        <thead className="text-[12px] text-muted" data-id="element-1791" data-mp="1e77texuyrfs8">
          <tr className="border-b border-line" data-id="element-1792" data-mp="1e8iyr2424vlg">
            {columns.map((c, i) => <th key={c.label} scope="col" className={`py-2 font-normal ${i === 0 ? 'sticky left-0 bg-white pl-4 pr-3 text-left sm:pl-0' : 'px-3 text-right'} ${i === columns.length - 1 ? 'pr-4 sm:pr-0' : ''}`} data-id="element-1793" data-mp="1j6svvi9ce69p" data-mpi={i}>
                {c.label}
              </th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-line" data-id="element-1794" data-mp="j5x5ukziwqzy">
          {rows.map((r, ri) => <tr key={ri} data-id="element-1795" data-mp="1gtfkudjs2pce" data-mpi={ri}>
              {r.map((cell, i) => {
            const kind = columns[i]?.kind ?? (i === 0 ? 'text' : 'number');
            const text = kind === 'text' ? cell === null || cell === '' ? '–' : String(cell) : fmt(typeof cell === 'number' ? cell : null, kind);
            return i === 0 ? <th key={i} scope="row" className="sticky left-0 max-w-[16rem] truncate bg-white py-2 pl-4 pr-3 text-left font-normal text-ink sm:pl-0" data-id="element-1796" data-mp="125aymzlinvov">
                    {text}
                  </th> : <td key={i} className={`px-3 py-2 text-right tabular-nums text-ink ${i === r.length - 1 ? 'pr-4 sm:pr-0' : ''}`} data-id="element-1797" data-mp="1urm34lc8ugqy">
                    {text}
                  </td>;
          })}
            </tr>)}
        </tbody>
      </table>
    </div>;
}

/** Voor de CSV: bedragen in euro's (centen / 100), de rest zoals hij is. */
export const csvRows = ({
  columns,
  rows
}: TableData): CsvCell[][] => rows.map(r => r.map((cell, i) => columns[i]?.kind === 'money' && typeof cell === 'number' ? cell / 100 : cell));